'use client';

import SmartImage from './SmartImage';
import ReferralButton from './ui/referral-button';

export default function ProfileTabAccountInfoBanner() {
  return (
    <div className="accountCampaignBanner">
      <SmartImage
        src="/campaign/referral_parts.png"
        alt="referral_parts"
        width={1800}
        height={216}
        className="absolute left-0 top-0 w-full h-full object-cover"
        sizes="100vw"
        priority
      />
      <div className="accountCampaignBannerInner flex-col sm:flex-row">
        <div className="referralContent text-center sm:text-left sm:items-start items-center">
          <div className="referralContentTop">Arkadaşını Öner, %20 İndirim Kazan!</div>
          <div className="referralContentBottom">
            Şimdi bir arkadaşına HızlıÇiçek’i öner, bir sonraki çiçek siparişinde{' '}
            <span>%20 indirimden</span> faydalan!
          </div>
        </div>
        <ReferralButton
          className="referralContentButton"
          clickedClassName="diagonal-animated referralContentButtonClicked"
        />
      </div>
    </div>
  );
}
